import { render } from "./PlansBotRiveRight.vue?vue&type=template&id=6f6f1f16&scoped=true"
import script from "./PlansBotRiveRight.vue?vue&type=script&lang=js"
export * from "./PlansBotRiveRight.vue?vue&type=script&lang=js"

import "./PlansBotRiveRight.vue?vue&type=style&index=0&id=6f6f1f16&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6f1f16"]])

export default __exports__